export const isCustomerPortalInBuilderMode = ()=>!!document.querySelector('[data-preview-mode="false"]');
export const isCustomerPortalInPreviewMode = ()=>{
    try {
        var _window;
        return (!!window.parent.document.querySelector('#cp-live-preview') || // Check if we're in a Flutter web app iframe on mobile
        !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.parent.navigator.userAgent) && window.parent !== window) && window !== ((_window = window) === null || _window === void 0 ? void 0 : _window.top);
    } catch (_e) {
        return false;
    }
};
export const isCustomerPortal = ()=>!!document.querySelector('.rl-cp-top-scroll-wrapper');
